module.exports = __webpack_public_path__ + "./Camille_pbw_8446913bc375940db7ff9c1a80d71011.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2024/Camille_pbw.png
// module id = 615
// module chunks = 0